export function toFaAlpha(text: string): string {
  return (
    text
      /** @example ي => ی */
      .replace(/\u064a/, "\u06cc")
      /** @example ى => ی */
      .replace(/\u0649/, "\u06cc")
      /** @example ك => ک */
      .replace(/\u0643/, "\u06a9")
      /** @example آ => ا */
      .replace(/\u0622/, "\u0627")
  );
}
